'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/ListNumbers.es.js";
const o = a.forwardRef((r, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...r, weights: e }));
o.displayName = "ListNumbersIcon";
const c = o;
export {
  c as ListNumbers,
  o as ListNumbersIcon
};
